import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from 'src/infrastructure/config';
import { OrderReturnDataRequest } from 'src/models/DTO/returns/orderReturnDataRequest';
import { OrderReturnRequests } from 'src/models/DTO/returns/orderReturnRequests';
import { CreateOrderReturnRequestModel } from 'src/models/requestModels/orders/CreateOrderReturnRequestModel';

@Injectable({
  providedIn: 'root'
})
export class OrderReturnServiceService {

  private returnOrderURL: string = Config.api + 'order/return/';
  private returnAllReturnOrdersURL: string = Config.api + 'order/return/search?include=order,items,items.order_line&sort=';


  constructor(private httpClient: HttpClient) { }

  createOrderReturn(orderToReturnUUID: string, orderReturnModel: CreateOrderReturnRequestModel) {
    return this.httpClient.post(this.returnOrderURL + orderToReturnUUID, orderReturnModel);
  }

  getAllOrderReturns(sort: string = "newest") {
    return this.httpClient.get<OrderReturnRequests>(this.returnAllReturnOrdersURL + sort);
  }

  getReturnInfo(returnUUID: string) {
    return this.httpClient.get<OrderReturnDataRequest>(this.returnOrderURL + returnUUID + '?include=order,items,items.order_line');
  }
}
